import { useEffect } from "react";
import { connect } from "react-redux";
import { setLocal } from "../actions/local";
import { supportedLocal } from "../utils";
import i18n from "../i18n";

function LayoutComponent({ setLocal, local }) {
  useEffect(() => {
    if (local) {
      i18n.changeLanguage(local);
    }
  }, [local]);

  useEffect(() => {
    if (!local) {
      setLocal(supportedLocal());
    }
  }, [setLocal, local]);

  return <div />;
}

const mapStateToProps = (state) => {
  return {
    ...state.Filters,
    ...state.Local,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLocal: (local) => dispatch(setLocal(local)),
  };
};

const appConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(LayoutComponent);

export default appConnect;
